export default "__VITE_ASSET__DST2kmuk__"